import { render, staticRenderFns } from "./NewsDetailsFive.vue?vue&type=template&id=39118cca"
import script from "./NewsDetailsFive.vue?vue&type=script&lang=js"
export * from "./NewsDetailsFive.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailsFive.vue?vue&type=style&index=0&id=39118cca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports